export enum UserType {
  WEB_USER = "web_user",
  IP_USER = "ip_user",
}
